module.exports = __webpack_public_path__ + "05_hair_gold.af532dc0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/female/layer5/05_hair_gold.png
// module id = 1TuR
// module chunks = 0